import React, { useEffect } from 'react';
import BottomNav from '../../../components/main-page/BottomNav';
import Header from './Header';
import Footer from './Footer';

const StoreLayout = ({ children }) => {
  useEffect(() => {
    // Load store CSS files when store layout mounts
    const cssFiles = [
      '/store/assets/css/bootstrap.min.css',
      '/store/assets/css/font-awesome.min.css',
      '/store/assets/css/material-design-iconic-font.min.css',
      '/store/assets/css/fontawesome-stars.css',
      '/store/assets/css/meanmenu.css',
      '/store/assets/css/owl.carousel.min.css',
      '/store/assets/css/slick.css',
      '/store/assets/css/animate.css',
      '/store/assets/css/jquery-ui.min.css',
      '/store/assets/css/venobox.css',
      '/store/assets/css/nice-select.css',
      '/store/assets/css/magnific-popup.css',
      '/store/assets/css/helper.css',
      '/store/assets/css/style.css',
      '/store/assets/css/responsive.css',
      '/store/assets/css/pakpoints-theme.css'
    ];

    // Create and append link tags for each CSS file
    const linkElements = cssFiles.map(href => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.id = `store-css-${href.split('/').pop()}`;
      return link;
    });

    // Check if already loaded to avoid duplicates
    linkElements.forEach(link => {
      if (!document.getElementById(link.id)) {
        document.head.appendChild(link);
      }
    });

    // Load JavaScript files in order.
    // Guard against a race: StrictMode (dev) double-invokes this effect, so two
    // chains load scripts concurrently. If a tag already exists we must wait for
    // it to FINISH loading (not resolve on mere existence), otherwise main.js can
    // run before plugins register (e.g. "$.scrollUp is not a function").
    const loadScript = (src, id) => {
      return new Promise((resolve, reject) => {
        const existing = document.getElementById(id);
        if (existing) {
          if (existing.dataset.loaded === 'true') {
            resolve();
          } else {
            existing.addEventListener('load', resolve);
            existing.addEventListener('error', reject);
          }
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.id = id;
        script.onload = () => { script.dataset.loaded = 'true'; resolve(); };
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    // Load scripts sequentially (order matters - plugins must load before main.js)
    // Order matches the template's script loading order
    const loadScripts = async () => {
      try {
        await loadScript('/store/assets/js/vendor/jquery-1.12.4.min.js', 'store-jquery');
        await loadScript('/store/assets/js/vendor/popper.min.js', 'store-popper');
        await loadScript('/store/assets/js/bootstrap.min.js', 'store-bootstrap');
        await loadScript('/store/assets/js/jquery.meanmenu.min.js', 'store-meanmenu');
        await loadScript('/store/assets/js/wow.min.js', 'store-wow');
        await loadScript('/store/assets/js/slick.min.js', 'store-slick');
        await loadScript('/store/assets/js/owl.carousel.min.js', 'store-owl-carousel');
        await loadScript('/store/assets/js/jquery.countdown.min.js', 'store-countdown');
        await loadScript('/store/assets/js/waypoints.min.js', 'store-waypoints');
        await loadScript('/store/assets/js/jquery.counterup.min.js', 'store-counterup');
        await loadScript('/store/assets/js/jquery.barrating.min.js', 'store-barrating');
        await loadScript('/store/assets/js/jquery-ui.min.js', 'store-jquery-ui');
        await loadScript('/store/assets/js/venobox.min.js', 'store-venobox');
        await loadScript('/store/assets/js/jquery.nice-select.min.js', 'store-nice-select');
        await loadScript('/store/assets/js/scrollUp.min.js', 'store-scrollup');
        await loadScript('/store/assets/js/main.js', 'store-main');
      } catch (error) {
        console.error('Error loading store scripts:', error);
      }
    };

    loadScripts();

    // Cleanup: remove CSS when component unmounts (optional - you may want to keep it)
    return () => {
      // Uncomment if you want to remove CSS when leaving store
      // linkElements.forEach(link => {
      //   const element = document.getElementById(link.id);
      //   if (element) element.remove();
      // });
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-grow pb-16 md:pb-0">{children}</div>
      <Footer />
      <BottomNav />
    </div>
  );
};

export default StoreLayout;
